export default {
    user:{},
    user_local: {},
    token: '',
    app_id: '5c374a10bf48b3021dde7571',
    $barramento:undefined,
    $querotaxiApi: null,
    menu:[],
    routes:[],
    versoes: [],
    versaoAtual: '1.1',
    empresaQueroTaxi: null,
    showInformeLGPD: false
}



// WEBPACK FOOTER //
// ./src/store/modules/system/state.js